export default {
    img: {
        folder: {
            create: {
                title: "Ordner anlegen",
                name : "Name des Ordners",
                store: "Anlegen",
                action: "Ordner anlegen",
                empty: "Zu dieser Anlage gibt es noch keine Bilder.",
                noimages: "In diesem Ordner sind noch keine Bilder."
            },
            image: {
                category: {
                    lgs: "LiftGuardian",
                    book: "Prüfbuch",
                    image: "Bilder aus Begehung"
                }
            }
        },

        upload: {
            action: "Bilder hochladen",
            drop  : "Dateien hier ablegen, um sie hochzuladen",
            running       : "Lade hoch: {done} / {total}",
            finished      : "{done} Dateien hochgeladen",
            finishedFailed: "{done} hochgeladen, {failed} fehlgeschlagen",
            waiting       : "{n} wartend",
            processing    : "{n} werden verarbeitet",
            retry : "Erneut versuchen",
            reason: {
                TOO_LARGE  : "Datei zu groß (max. 10 MB)",
                UNSUPPORTED: "Dateityp nicht unterstützt",
                TIMEOUT    : "Zeitüberschreitung",
            },
            state: {
                FAILED: "Fehler"
            }
        },

        download: {
            action: "Herunterladen",
            done  : "Die ZIP Datei wurde im Download Verzeichis abgelegt",
            failed: "Der Download ist fehlgeschlagen"
        }
    },
}